import PortalIdParser from 'PortalIdParser';
export const getIntegrationSettingsPath = () => `/integrations-settings/${PortalIdParser.get()}/installed`;
export const getAppSettingsUrl = appId => `${getIntegrationSettingsPath()}/application/${appId}`;